<script setup>
import { computed } from 'vue';

const props = defineProps({
    flat: {
        type: Boolean,
        default: false
    },
    compact: {
        type: Boolean,
        default: false
    },
    bgColor: {
        type: String,
        default: 'bg-white'
    }
});
const containerClasses = computed(() => (props.flat ? 'bg-dashboard-primary-light' : ''));
const compact = computed(() => (props.compact ? 'p-2 ' : 'p-8 '));
</script>
<template>
    <div class="rounded-lg dark:bg-gray-800 transition-colors duration-200" :class="[containerClasses, compact, bgColor]">
        <slot />
    </div>
</template>
